import { pk, string } from 'fc-decoders'

import {
  PROP_ID,
  PROP_VALUE,
  PROP_KEY,
  PROP_CLIENT,
} from 'fc-model-environment'

export default {
  [PROP_ID]: pk,
  [PROP_VALUE]: string,
  [PROP_KEY]: string,
  [PROP_CLIENT]: pk,
}
